import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinmumbai() {



    const cardData = {
"keyword": "Ertiga On Rent in Mumbai",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Ertiga on rent in Mumbai for travelers looking for a safe, budget-friendly, and spacious travel option. Whether you need a vehicle for airport transfers, family trips, corporate travel, weddings, or outstation journeys like Mumbai to Pune, Lonavala, Shirdi, Nashik, or Mahabaleshwar, our Ertiga rental service ensures a smooth and stress-free ride. With experienced drivers, well-maintained and clean vehicles, and transparent pricing with no hidden charges, we provide a dependable travel solution across Mumbai. The Ertiga is an ideal choice for small families and groups, offering comfortable seating, good luggage space, and efficient long-distance travel comfort.",

"topPlaces": [
 
  {
    "title": "Goa",
    "description": "India’s top beach destination famous for nightlife, beaches, water sports, and Portuguese heritage."
  },
   {
    "title": "Lonavala",
    "description": "Popular hill station near Mumbai known for Bhushi Dam, green valleys, waterfalls, and weekend trips."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Famous hill station in Maharashtra known for strawberries, viewpoints, and cool climate."
  },
  {
    "title": "Nashik",
    "description": "Religious and wine capital of India known for Trimbakeshwar Temple and vineyards."
  },
  {
    "title": "Shirdi",
    "description": "Holy pilgrimage town dedicated to Sai Baba attracting millions of devotees every year."
  },
  {
    "title": "Pune",
    "description": "Cultural and educational hub known for forts, IT parks, and pleasant weather."
  },
  {
    "title": "Aurangabad",
    "description": "Historic city famous for Ajanta & Ellora Caves, UNESCO World Heritage sites."
  },
  {
    "title": "Alibaug",
    "description": "Coastal town near Mumbai known for beaches, resorts, and weekend getaways."
  },
  {
    "title": "Kolhapur",
    "description": "Cultural city famous for Mahalaxmi Temple, Kolhapuri cuisine, and history."
  },
  {
    "title": "Ratnagiri",
    "description": "Scenic Konkan coastal destination known for beaches, mangoes, and forts."
  }
],



services: [
  {
    name: "Ertiga Car on Rent in Mumbai",
    description: "Ertiga car on rent in Mumbai service provides spacious and comfortable transportation for travelers planning local and outstation road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Ertiga CNG on Rent in Mumbai",
    description: "Ertiga CNG on rent in Mumbai service offers economical and comfortable transportation for travelers seeking fuel-efficient road journeys. Ertiga CNG vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, family outings, and local travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Ertiga CNG rental reservations."
  },
  {
    name: "Ertiga on Hire in Mumbai",
    description: "Ertiga on hire in Mumbai service provides dependable transportation with spacious seating for smooth local and outstation road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for family vacations, tourism travel, airport transfers, and business trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Ertiga hire reservations."
  },
  {
    name: "Ertiga Rent Per KM in Mumbai",
    description: "Ertiga rent per KM in Mumbai service provides affordable transportation pricing for travelers planning flexible local and outstation road travel. Ertiga vehicles ensure smooth city and highway journeys suitable for tourism travel, executive trips, airport transfers, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient per kilometer Ertiga rental reservations."
  },
  {
    name: "Ertiga On Rent in Mumbai",
    description: "Ertiga on rent in Mumbai service provides reliable transportation for travelers seeking comfortable 7 seater road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, family holidays, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Mumbai Ertiga Rental",
    description: "Mumbai Ertiga rental service offers spacious transportation with comfortable vehicles suitable for family and group travel. Ertiga vehicles ensure reliable highway and city travel ideal for tourism trips, airport transfers, family outings, and business travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Ertiga Cab Service Mumbai",
    description: "Ertiga cab service Mumbai provides dependable transportation with spacious seating for local and outstation road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for tourism trips, airport transfers, family vacations, and executive travel. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Ertiga Taxi Mumbai",
    description: "Ertiga taxi Mumbai service provides comfortable transportation for travelers planning smooth local and outstation road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for airport transfers, tourism travel, family outings, and executive trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Ertiga taxi reservations."
  },
  {
    name: "Ertiga Hire Mumbai",
    description: "Ertiga hire Mumbai service offers dependable transportation with spacious vehicles suitable for comfortable road journeys. Ertiga vehicles ensure smooth highway and city travel ideal for tourism travel, family holidays, airport transfers, and business trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Ertiga hire reservations."
  },
  {
    name: "Mumbai Ertiga Booking",
    description: "Mumbai Ertiga booking service provides quick and convenient transportation reservations for travelers planning comfortable road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Ertiga booking reservations."
  },
  {
    name: "AC Ertiga on Rent Mumbai",
    description: "AC Ertiga on rent Mumbai service provides air-conditioned transportation for travelers seeking comfortable and relaxing road journeys. Ertiga vehicles ensure cool and smooth city and highway travel suitable for airport transfers, tourism trips, family vacations, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient AC Ertiga rental reservations."
  },
  {
    name: "Ertiga Car Rental Mumbai",
    description: "Ertiga car rental Mumbai service provides spacious and reliable transportation for travelers planning smooth local and outstation road travel. Ertiga vehicles ensure comfortable seating and dependable highway travel suitable for family outings, tourism trips, and airport transfers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Mumbai. Flexible booking options allow convenient Ertiga car rental reservations."
  },
  {
    name: "Mumbai 7 Seater Ertiga Cab",
    description: "Mumbai 7 seater Ertiga cab service provides spacious transportation for families and groups planning comfortable road journeys. Ertiga vehicles ensure smooth city and highway travel with comfortable seating and luggage capacity suitable for tourism travel and airport transfers. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient 7 seater Ertiga reservations."
  },
  {
    name: "Ertiga On Rent in Navi Mumbai",
    description: "Ertiga on rent in Navi Mumbai service provides comfortable transportation for travelers planning smooth local and outstation road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, family outings, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Navi Mumbai Ertiga Rental",
    description: "Navi Mumbai Ertiga rental service offers spacious transportation with dependable vehicles for comfortable road journeys. Ertiga vehicles ensure smooth highway and city travel suitable for tourism travel, family holidays, airport transfers, and business trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Ertiga Cab Service Navi Mumbai",
    description: "Ertiga cab service Navi Mumbai provides dependable transportation with spacious seating for local and outstation travel requirements. Ertiga vehicles ensure reliable city and highway journeys suitable for tourism trips, airport transfers, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Navi Mumbai. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Ertiga Taxi Navi Mumbai",
    description: "Ertiga taxi Navi Mumbai service provides comfortable transportation for travelers seeking reliable local and outstation road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, family outings, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Ertiga taxi reservations."
  },
  {
    name: "Navi Mumbai Ertiga Booking",
    description: "Navi Mumbai Ertiga booking service provides quick transportation reservations for travelers planning spacious and comfortable road journeys. Ertiga vehicles ensure dependable city and highway travel suitable for tourism trips, airport transfers, family vacations, and executive travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient Ertiga booking reservations."
  },
  {
    name: "Ertiga Car Rental Navi Mumbai",
    description: "Ertiga car rental Navi Mumbai service provides reliable transportation with spacious seating for comfortable local and outstation road travel. Ertiga vehicles ensure smooth highway and city travel suitable for tourism travel, family holidays, and airport transfers. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Ertiga car rental reservations."
  },
  {
    name: "Navi Mumbai 7 Seater Cab",
    description: "Navi Mumbai 7 seater cab service offers spacious transportation for families and groups planning comfortable road journeys. 7 seater vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Navi Mumbai. Flexible booking options allow convenient 7 seater cab reservations."
  },
  {
    name: "Family Cab Service Navi Mumbai",
    description: "Family cab service Navi Mumbai provides comfortable and spacious transportation for families planning smooth local and outstation road journeys. Vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, family outings, and holiday travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient family cab reservations."
  },
  {
    name: "Ertiga On Rent in Thane",
    description: "Ertiga on rent in Thane service provides dependable transportation with spacious seating for local and outstation road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for tourism travel, airport transfers, family vacations, and executive trips. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Thane. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Best Ertiga On Rent in Panvel",
    description: "Best Ertiga on rent in Panvel service provides premium transportation with comfortable vehicles for smooth local and outstation road journeys. Ertiga vehicles ensure reliable highway and city travel suitable for tourism travel, airport transfers, family holidays, and executive journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Panvel. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Cheap Ertiga Rental Panvel",
    description: "Cheap Ertiga rental Panvel service offers budget-friendly transportation for travelers planning economical road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, family outings, and local travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Panvel. Flexible booking options allow convenient low-cost Ertiga rental reservations."
  },
  {
    name: "Online Ertiga Booking Panvel",
    description: "Online Ertiga booking Panvel service provides quick and convenient transportation reservations for travelers planning comfortable road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, family vacations, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Panvel. Flexible online booking options allow convenient Ertiga reservations."
  },
  {
    name: "Ertiga On Rent Navi Mumbai Airport",
    description: "Ertiga on rent Navi Mumbai Airport service provides dependable airport transportation with spacious seating for comfortable pickup and drop road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for airport transfers, tourism trips, and family travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available directly from Navi Mumbai Airport terminals and nearby airport areas. Flexible booking options allow convenient airport Ertiga rental reservations."
  },
  {
    name: "Navi Mumbai Airport Ertiga Cab",
    description: "Navi Mumbai Airport Ertiga cab service offers comfortable airport transportation for travelers planning smooth pickup and drop journeys. Ertiga vehicles ensure reliable city and highway travel suitable for airport transfers, tourism trips, family vacations, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available directly from Navi Mumbai Airport terminals and nearby airport locations. Flexible booking options allow convenient airport Ertiga cab reservations."
  },
  {
    name: "Navi Mumbai Airport Ertiga Taxi",
    description: "Navi Mumbai Airport Ertiga taxi service provides reliable airport transportation for travelers planning spacious and comfortable road journeys. Ertiga vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, family outings, and executive trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available directly from Navi Mumbai Airport terminals and nearby airport areas. Flexible booking options allow convenient airport Ertiga taxi reservations."
  }
],

tableData: [
  ["Ertiga Car on Rent in Mumbai", "Ertiga CNG on Rent in Mumbai"],
  ["Ertiga on Hire in Mumbai", "Ertiga Rent Per KM in Mumbai"],
  ["Ertiga On Rent in Mumbai", "Mumbai Ertiga Rental"],
  ["Ertiga Cab Service Mumbai", "Ertiga Taxi Mumbai"],
  ["Ertiga Hire Mumbai", "Mumbai Ertiga Booking"],
  ["AC Ertiga on Rent Mumbai", "Ertiga Car Rental Mumbai"],
  ["Mumbai 7 Seater Ertiga Cab", "Ertiga On Rent in Navi Mumbai"],
  ["Navi Mumbai Ertiga Rental", "Ertiga Cab Service Navi Mumbai"],
  ["Ertiga Taxi Navi Mumbai", "Navi Mumbai Ertiga Booking"],
  ["Ertiga Car Rental Navi Mumbai", "Navi Mumbai 7 Seater Cab"],
  ["Family Cab Service Navi Mumbai", "Ertiga On Rent in Thane"],
  ["Best Ertiga On Rent in Panvel", "Cheap Ertiga Rental Panvel"],
  ["Online Ertiga Booking Panvel", "Ertiga On Rent Navi Mumbai Airport"],
  ["Navi Mumbai Airport Ertiga Cab", "Navi Mumbai Airport Ertiga Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Ertiga On Rent in Mumbai",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Ertiga on rent in Mumbai with professional drivers, comfortable seating, and smooth travel for local, airport, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Ertiga Rental Fare in Mumbai",
    WhyChoosedescription: "Our Mumbai Ertiga rental service offers affordable pricing with transparent fare details and no hidden charges for family trips, airport transfers, and corporate travel."
  },
  {
    WhyChooseheading: "24/7 Ertiga Cab Availability in Mumbai",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Ertiga bookings in Mumbai including airport pickups, railway station transfers, local travel, and emergency transportation."
  },
  {
    WhyChooseheading: "Comfortable & Spacious AC Ertiga Cabs",
    WhyChoosedescription: "All Ertiga vehicles are fully air-conditioned, sanitized, spacious, and maintained regularly to provide smooth and comfortable travel experiences."
  },
  {
    WhyChooseheading: "Local & Outstation Ertiga Booking Options",
    WhyChoosedescription: "Customers can book Ertiga for Mumbai local travel, airport transfers, one-way trips, round-trip journeys, sightseeing tours, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Perfect 7 Seater Family Travel Vehicle",
    WhyChoosedescription: "Ertiga is ideal for family vacations, group travel, airport pickups, business rides, and weekend trips with spacious seating and luggage comfort."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup service from Mumbai Airport, Navi Mumbai, Thane, hotels, homes, railway stations, offices, and all major Mumbai locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai city roads, airport routes, highways, and tourist destinations to ensure safe driving and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is Ertiga on rent service in Mumbai?",
    answer: "Ertiga on rent service in Mumbai provides comfortable 7 seater taxi transportation for local travel, airport transfers, sightseeing tours, and outstation journeys."
  },
  {
    question: "Is Ertiga rental service available 24 hours in Mumbai?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Ertiga rental service in Mumbai."
  },
  {
    question: "Can I book Ertiga for outstation travel from Mumbai?",
    answer: "Yes, customers can book Ertiga for one-way and round-trip outstation travel from Mumbai."
  },
  {
    question: "Do you provide Mumbai Airport pickup and drop with Ertiga?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service using Ertiga from Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Is Ertiga suitable for family travel?",
    answer: "Yes, Ertiga is a spacious 7 seater vehicle ideal for family trips and group travel."
  },
  {
    question: "Are all Ertiga vehicles air-conditioned?",
    answer: "Yes, all Ertiga vehicles are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book Ertiga on rent online in Mumbai?",
    answer: "Yes, customers can easily book Ertiga rental service online or through phone booking."
  },
  {
    question: "Do you provide Ertiga for corporate travel in Mumbai?",
    answer: "Yes, comfortable Ertiga vehicles are available for corporate travel, business meetings, and executive transportation."
  },
  {
    question: "Are Mumbai Ertiga rental fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Ertiga rental in Mumbai?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel schedules."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Shinde",
    feedback: "Rented an Ertiga in Mumbai from Om Sai Cab Service for a family outing and had a very comfortable experience. The vehicle was clean, spacious, and ideal for group travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha More",
    feedback: "Took an Ertiga on rent in Mumbai through Om Sai Cab Service and everything was well managed. The cab was in good condition and the ride felt smooth and hassle-free.",
    rating: 5
  }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Mumbai",
  "image": "http://www.omsaicabservice.com/assets/images/ertiga-on-rent-mumbai.jpg",
  "description": "Book Ertiga on rent in Mumbai with Om Sai Cab Service for local, airport, and outstation travel. Affordable 6-7 seater AC and CNG Ertiga cabs available for family trips, airport transfers, and intercity travel across Mumbai, Navi Mumbai, Thane, and Panvel with driver service.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/ertiga-on-rent-in-mumbai"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Ertiga On Rent in Mumbai | 7 Seater Family Cab Hire | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Ertiga on rent in Mumbai for family trips, airport transfers, and outstation travel. Affordable 7-seater AC and CNG Ertiga cabs available across Mumbai, Navi Mumbai, Thane, and Panvel with driver service."
  />

  <meta
    name="keywords"
    content="ertiga car on rent in mumbai, ertiga cng on rent in mumbai, Ertiga on hire in mumbai, Ertiga rent per km in mumbai, Ertiga On Rent in Mumbai, Mumbai Ertiga Rental, Ertiga Cab Service Mumbai, Ertiga Taxi Mumbai, Ertiga Hire Mumbai, Mumbai Ertiga Booking, AC Ertiga on Rent Mumbai, Ertiga Car Rental Mumbai, Mumbai 7 Seater Ertiga Cab, Ertiga On Rent in Navi Mumbai, Navi Mumbai Ertiga Rental, Ertiga Cab Service Navi Mumbai, Ertiga Taxi Navi Mumbai, Navi Mumbai Ertiga Booking, Ertiga Car Rental Navi Mumbai, Navi Mumbai 7 Seater Cab, Family Cab Service Navi Mumbai, Ertiga On Rent in Thane, Best Ertiga On Rent in Panvel"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinmumbai;